import React from 'react';
import IncomeSection
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Content/IncomeSection';

const GrossMonthlyIncomeSection = () => {
  return (
    <IncomeSection showTitle={false} />
  );
};

GrossMonthlyIncomeSection.defaultProps = {
};

GrossMonthlyIncomeSection.propTypes = {
};

export default GrossMonthlyIncomeSection;
